import Pusher from "pusher-js";

class PusherService {
	constructor() {
		this.pusher = null;
		this.channels = new Map();
	}

	ensureConnection() {
		if (this.pusher) return;
		const key = process.env.VUE_APP_PUSHER_KEY;
		const cluster = process.env.VUE_APP_PUSHER_CLUSTER;

		if (!key || !cluster) console.warn("[PusherService] Missing VUE_APP_PUSHER_KEY or VUE_APP_PUSHER_CLUSTER");

		this.pusher = new Pusher(key, { cluster, forceTLS: true });
		this.pusher.connection.bind("error", (e) => console.error("[Pusher] error", e));
	}

	listen(channelName, eventName, cb) {
		this.ensureConnection();
		let ch = this.channels.get(channelName);
		if (!ch) {
			ch = this.pusher.subscribe(channelName);
			this.channels.set(channelName, ch);
		}
		const handler = (data) => cb(data);
		ch.bind(eventName, handler);
		return () => ch.unbind(eventName, handler);
	}

	listenMany(channelName, events, onEvent) {
		return events.map((e) => this.listen(channelName, e, (p) => onEvent(e, p)));
	}

	unsubscribe(channelName) {
		if (!this.pusher) return;
		if (this.channels.has(channelName)) {
			this.pusher.unsubscribe(channelName);
			this.channels.delete(channelName);
		}
	}

	disconnect() {
		if (!this.pusher) return;
		for (const name of this.channels.keys()) this.pusher.unsubscribe(name);
		this.channels.clear();
		this.pusher.disconnect();
		this.pusher = null;
	}
}

export default new PusherService();
